<script>
    import { push } from "svelte-spa-router";
    //export let params;
    function Dashboard() {
        push("/dashboard/products");
    }
</script>

<div style="width:400px; height:400px; background-color:#F00;color:white">
    product saved
    <btn class="btn btn-primary" on:click={Dashboard}>Dashboard</btn>
</div>
